if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomButton = null;
        this.zoomTarget = null;
        this.onZoomButtonClick = this.onZoomButtonClick.bind(this);
        this.onWindowResize = this.onWindowResize.bind(this);
        this.ensureZoomButton();
        window.addEventListener('resize', this.onWindowResize);
      }

      connectedCallback() {
        super.connectedCallback();
        this.ensureZoomButton();
        // Dawn moves this modal into document.body on first connection.
        // Re-registering the same bound handler is safe and preserves reset-on-rotation.
        window.addEventListener('resize', this.onWindowResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onWindowResize);
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      ensureZoomButton() {
        if (this.zoomButton) return;

        const dialog = this.querySelector('.product-media-modal__dialog');
        if (!dialog) return;

        this.zoomButton = document.createElement('button');
        this.zoomButton.type = 'button';
        this.zoomButton.className = 'product-media-modal__zoom';
        this.zoomButton.hidden = true;
        this.zoomButton.setAttribute('aria-label', 'Zoom image to 2 times');
        this.zoomButton.setAttribute('aria-pressed', 'false');
        this.zoomButton.textContent = 'Zoom 2×';

        // Dawn closes a media modal on a mouse pointer-up outside media.
        // Keep a click on this control from being treated as a backdrop click.
        this.zoomButton.addEventListener('pointerup', (event) => event.stopPropagation());
        this.zoomButton.addEventListener('click', this.onZoomButtonClick);
        dialog.appendChild(this.zoomButton);
      }

      showActiveMedia() {
        this.resetZoom();

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        this.updateZoomButton(activeMedia);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      updateZoomButton(activeMedia) {
        this.ensureZoomButton();
        if (!this.zoomButton) return;

        const isImage = activeMedia && activeMedia.nodeName === 'IMG';
        this.zoomButton.hidden = !isImage;
        this.zoomButton.setAttribute('aria-pressed', 'false');
        this.zoomButton.setAttribute('aria-label', 'Zoom image to 2 times');
        this.zoomButton.textContent = 'Zoom 2×';
      }

      onZoomButtonClick() {
        if (!window.matchMedia('(max-width: 749px)').matches) return;

        if (this.classList.contains('is-image-zoomed')) {
          this.resetZoom();
        } else {
          this.enableZoom();
        }
      }

      enableZoom() {
        const image = this.querySelector('.product-media-modal__content > img.active');
        const container = this.querySelector('[role="document"]');
        if (!image || !container) return;

        const fittedImage = image.getBoundingClientRect();
        image.style.setProperty('--mobile-zoom-width', `${Math.round(fittedImage.width * 2)}px`);
        image.style.setProperty('--mobile-zoom-height', `${Math.round(fittedImage.height * 2)}px`);
        this.zoomTarget = image;
        this.classList.add('is-image-zoomed');

        this.zoomButton.setAttribute('aria-pressed', 'true');
        this.zoomButton.setAttribute('aria-label', 'Reset image zoom');
        this.zoomButton.textContent = 'Reset zoom';

        requestAnimationFrame(() => {
          container.scrollLeft = Math.max(0, (container.scrollWidth - container.clientWidth) / 2);
          container.scrollTop = Math.max(0, (container.scrollHeight - container.clientHeight) / 2);
        });
      }

      resetZoom() {
        const container = this.querySelector('[role="document"]');

        if (this.zoomTarget) {
          this.zoomTarget.style.removeProperty('--mobile-zoom-width');
          this.zoomTarget.style.removeProperty('--mobile-zoom-height');
        }

        this.zoomTarget = null;
        this.classList.remove('is-image-zoomed');

        if (container) {
          container.scrollLeft = 0;
          container.scrollTop = 0;
        }

        if (this.zoomButton && !this.zoomButton.hidden) {
          this.zoomButton.setAttribute('aria-pressed', 'false');
          this.zoomButton.setAttribute('aria-label', 'Zoom image to 2 times');
          this.zoomButton.textContent = 'Zoom 2×';
        }
      }

      onWindowResize() {
        if (this.hasAttribute('open')) this.resetZoom();
      }
    }
  );
}
